import { createAction } from 'redux-api-middleware';
import Config from '../config';
import Platform from '../platform';
import {
    AcceptTerms,
    AllowMarketing,
    ApplyPromoCode,
    CheckConnection,
    CheckDiscount,
    CheckPaymentStatus,
    CheckPhoneCode,
    CheckZip,
    DeleteCard,
    EmailReceipts,
    GetAppSettings,
    GetAppSettingsByRestaurant,
    GetAppTranslation,
    GetCashPoints,
    GetCustomerDetails,
    GetDetails,
    GetMenu,
    GetOrder,
    GetOrderDates,
    GetOrderTimeSlots,
    GetRestaurantList,
    GetRestaurantListByZip,
    LoginAnonymous,
    OldOrders,
    RegisterStripeCard,
    ResendPhoneCode,
    Resignup,
    SendClientLog,
    SendOrder,
    SendReceipt,
    SetBirthdate,
    SetEmail,
    SetLocale,
    SetPhone,
    SetTable,
    SetUsername,
    RegisterAdyenCard,
    SetGuestInfo
} from 'new-constants/api-urls.constants';
import {
    RESTAURANT_REQUEST,
    RESTAURANT_SUCCESS,
    RESTAURANT_FAILURE,
    CHECK_CONNECTION_REQUEST,
    CHECK_CONNECTION_SUCCESS,
    CHECK_CONNECTION_FAILURE,
    RESTAURANT_LIST_REQUEST,
    RESTAURANT_LIST_SUCCESS,
    RESTAURANT_LIST_FAILURE,
    LOGIN_ANONYMOUS_REQUEST,
    LOGIN_ANONYMOUS_SUCCESS,
    LOGIN_ANONYMOUS_FAILURE,
    RESIGNUP_FAILURE,
    RESIGNUP_REQUEST,
    RESIGNUP_SUCCESS,
    CUSTOMER_SUCCESS,
    CUSTOMER_FAILURE,
    CUSTOMER_REQUEST,
    MENU_REQUEST,
    MENU_SUCCESS,
    MENU_FAILURE,
    SERVER_CONFIG_REQUEST,
    SERVER_CONFIG_SUCCESS,
    SERVER_CONFIG_FAILURE,
    SERVER_CONFIG_BY_RESTAURANT_REQUEST,
    SERVER_CONFIG_BY_RESTAURANT_SUCCESS,
    SERVER_CONFIG_BY_RESTAURANT_FAILURE,
    DISCOUNT_SUCCESS,
    DISCOUNT_REQUEST,
    DISCOUNT_FAILURE,
    ORDER_DATES_REQUEST,
    ORDER_DATES_SUCCESS,
    ORDER_DATES_FAILURE,
    ORDER_TIME_SLOTS_REQUEST,
    ORDER_TIME_SLOTS_SUCCESS,
    ORDER_TIME_SLOTS_FAILURE,
    SET_PHONE_REQUEST,
    SET_PHONE_SUCCESS,
    SET_PHONE_FAILURE,
    CHECK_PHONE_CODE_REQUEST,
    CHECK_PHONE_CODE_SUCCESS,
    CHECK_PHONE_CODE_FAILURE,
    SEND_ORDER_REQUEST,
    SEND_ORDER_SUCCESS,
    SEND_ORDER_FAILURE,
    OLD_ORDERS_REQUEST,
    OLD_ORDERS_SUCCESS,
    OLD_ORDERS_FAILURE,
    SET_LOCALE_REQUEST,
    SET_LOCALE_FAILURE,
    SET_LOCALE_SUCCESS,
    SET_EMAIL_REQUEST,
    SET_EMAIL_SUCCESS,
    SET_EMAIL_FAILURE,
    CASHPOINTS_SUCCESS,
    CASHPOINTS_FAILURE,
    CASHPOINTS_REQUEST,
    CHECK_ZIP_REQUEST,
    CHECK_ZIP_SUCCESS,
    CHECK_ZIP_FAILURE,
    APPLY_PROMOCODE_REQUEST,
    APPLY_PROMOCODE_FAILURE,
    APPLY_PROMOCODE_SUCCESS,
    SET_TABLE_REQUEST,
    SET_TABLE_SUCCESS,
    SET_TABLE_FAILURE,
    CHECK_PAYMENT_STATUS_REQUEST,
    CHECK_PAYMENT_STATUS_FAILURE,
    CHECK_PAYMENT_STATUS_SUCCESS,
    RESTAURANT_LIST_BY_ZIP_REQUEST,
    RESTAURANT_LIST_BY_ZIP_SUCCESS,
    RESTAURANT_LIST_BY_ZIP_FAILURE,
    SET_NAME_REQUEST,
    SET_NAME_SUCCESS,
    SET_NAME_FAILURE,
    SET_BIRTHDATE_REQUEST,
    SET_BIRTHDATE_SUCCESS,
    SET_BIRTHDATE_FAILURE,
    CHECK_PHONE_CODE,
    DELETE_CARD_REQUEST,
    DELETE_CARD_SUCCESS,
    DELETE_CARD_FAILURE,
    ORDER_REQUEST,
    ORDER_SUCCESS,
    ORDER_FAILURE,
    EMAIL_RECEIPTS_REQUEST,
    EMAIL_RECEIPTS_SUCCESS,
    EMAIL_RECEIPTS_FAILURE,
    SEND_RECEIPT_REQUEST,
    SEND_RECEIPT_SUCCESS,
    SEND_RECEIPT_FAILURE,
    RESEND_PHONE_CODE_REQUEST,
    RESEND_PHONE_CODE_SUCCESS,
    RESEND_PHONE_CODE_FAILURE,
    ALLOW_MARKETING_REQUEST,
    ALLOW_MARKETING_FAILURE,
    ALLOW_MARKETING_SUCCESS,
    REGISTER_STRIPE_CARD_REQUEST,
    REGISTER_STRIPE_CARD_SUCCESS,
    REGISTER_STRIPE_CARD_FAILURE,
    LOCALIZATION_REQUEST,
    LOCALIZATION_SUCCESS,
    LOCALIZATION_FAILURE,
    ACCEPT_TERMS_REQUEST,
    ACCEPT_TERMS_SUCCESS,
    ACCEPT_TERMS_FAILURE,
    SEND_CLIENT_LOG_REQUEST,
    SEND_CLIENT_LOG_SUCCESS,
    SEND_CLIENT_LOG_FAILURE,
} from 'new-constants/api.constants';
import { DefaultValues } from 'new-constants/common.constants';
import isArray from 'lodash/isArray';
import {
    PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
    STRIPE_CARD_REGISTRATION_POPUP,
} from 'new-components/popups/stripe-card-registration/StripeCardRegistration';
import { DELIVERY_ADDRESS_POPUP } from 'new-components/popups/delivery-address/DeliveryAddress';
import { PROMOCODE_EDIT_POPUP } from 'new-components/popups/promocode-edit/PromocodeEdit';
import { TABLE_EDIT_POPUP } from 'new-components/popups/table-edit/TableEdit';
import { INITIAL_POPUP } from 'new-components/popups/initial/Initial';
import { MainCategoryTypes, PaymentTypes } from 'new-constants/common.constants';
import { VIPPS_PAYMENT_FRAME_POPUP } from 'new-components/popups/vipps-payment-frame/VippsPaymentFrame';
import { SELECT_LOCATION_POPUP } from 'new-components/popups/select-location/SelectLocation';
import { NAME_POPUP } from 'new-components/popups/name/Name';
import { EMAIL_POPUP } from 'new-components/popups/email/Email';
import { BIRTHDAY_POPUP } from 'new-components/popups/birthday/Birthday';
import { VERIFICATION_CODE_POPUP } from 'new-components/popups/verification-code/VerificationCode';
import { PHONE_POPUP } from 'new-components/popups/phone/Phone';
import {
    getAvailableOrderingTypesSelector,
    getCurrentAppIdSelector,
    getCurrentAuthSelector,
    getCurrentRestaurantIdSelector,
    getCurrentRestaurantListSelector,
    getCurrentOrdersSelector,
    getOrderCacheSelector,
    getCurrentCustomerSelector,
    getCurrentTemporaryOrderIdSelector, getAdyenRedirectResultSelector, getAdyenReturnModeSelector, getAdyenRedirectResultSecret,
} from '../selectors';
import {
    DISCOUNT_ERROR_MESSAGE_POPUP,
    SEND_ORDER_ERROR_MESSAGE_POPUP,
    MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP
} from 'new-components/popups/error-message/ErrorMessage';
import { EMAIL_ALL_RECEIPTS_POPUP, EMAIL_RECEIPT_POPUP } from 'new-components/popups/email-receipt/EmailReceipt';
import { encrypt, decrypt } from 'helpers/encryption.helper';
import { getBrowserFullLocale, getBrowserShortLocaleAdaptedForBackend } from 'helpers/localization.helper.ts';
import { TERMS_POPUP } from 'new-components/popups/terms/Terms';
import { ZIP_EDIT_POPUP } from 'new-components/popups/zip-edit/ZipEdit';
import { AppId } from '../helpers/restaurant.helper.types';
import { Secret, Udid } from '../reducers/auth.reducer.types';
import { RestaurantId } from '../helpers/restaurant.helper.types';
import { Menu } from '../helpers/menu.helper.types';
import { ADD_TO_HOME_SCREEN_POPUP } from '../components/popups/add-to-home-screen/AddToHomeScreen';
import {
    AppOrders,
    CancelOrder,
    CheckAdyenPayment, CheckPaymentStatusAnonymously,
    InitAdyenPayment,
    MarkPopupAsShown,
    RepeatOrder
} from '../constants/api-urls.constants';
import {
    CANCEL_ORDER_FAILURE,
    CANCEL_ORDER_REQUEST,
    CANCEL_ORDER_SUCCESS,
    CHECK_ADYEN_PAYMENT_FAILURE,
    CHECK_ADYEN_PAYMENT_REQUEST,
    CHECK_ADYEN_PAYMENT_SUCCESS,
    CHECK_PAYMENT_STATUS_ANONYMOUSLY_FAILURE,
    CHECK_PAYMENT_STATUS_ANONYMOUSLY_REQUEST,
    CHECK_PAYMENT_STATUS_ANONYMOUSLY_SUCCESS,
    GET_HISTORY_ORDERS_FAILURE,
    GET_HISTORY_ORDERS_REQUEST,
    GET_HISTORY_ORDERS_SUCCESS,
    INIT_ADYEN_PAYMENT_FAILURE,
    INIT_ADYEN_PAYMENT_REQUEST,
    INIT_ADYEN_PAYMENT_SUCCESS,
    MARK_POPUP_AS_SHOWN_FAILURE,
    MARK_POPUP_AS_SHOWN_REQUEST,
    MARK_POPUP_AS_SHOWN_SUCCESS,
    ORDER_DATES,
    ORDER_TIME_SLOTS,
    REGISTER_ADYEN_CARD_FAILURE,
    REGISTER_ADYEN_CARD_REQUEST,
    REGISTER_ADYEN_CARD_SUCCESS,
    REGISTER_STRIPE_CARD,
    REPEAT_ORDER_FAILURE,
    REPEAT_ORDER_REQUEST,
    REPEAT_ORDER_SUCCESS, SET_GUEST_FAILURE, SET_GUEST_REQUEST, SET_GUEST_SUCCESS,
    SUBMIT_APPLE_PAY_FAILURE,
    SUBMIT_APPLE_PAY_REQUEST,
    SUBMIT_APPLE_PAY_SUCCESS,
    SUBMIT_GOOGLE_PAY_FAILURE,
    SUBMIT_GOOGLE_PAY_REQUEST,
    SUBMIT_GOOGLE_PAY_SUCCESS,
    SUBMIT_SWISH_PAY_FAILURE,
    SUBMIT_SWISH_PAY_REQUEST,
    SUBMIT_SWISH_PAY_SUCCESS
} from '../constants/api.constants';
import {
    REPEAT_ORDER_CONFIRMATION_POPUP,
    REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP
} from '../components/popups/confirmation/Confirmation';
import { getOrderFromCache, getOrderingTypeFromOrder } from '../helpers/order.helper';
import { ORDERS_POPUP } from '../components/popups/orders/Orders';
import { AdyenReturnModes, OrderingTypes, PaymentStatuses } from '../constants/common.constants';
import { CART_DELIVERY_ADDRESS_POPUP } from '../components/popups/delivery-address/DeliveryAddress';
import { CART_ZIP_EDIT_POPUP } from '../components/popups/zip-edit/ZipEdit';
import { CART_SELECT_LOCATION_POPUP } from '../components/popups/select-location/SelectLocation';
import {
    ADYEN_APPLE_PAY_POPUP,
    ADYEN_CARD_REGISTRATION_POPUP, ADYEN_GOOGLE_PAY_POPUP, CONFIRM_GUEST_ORDER_POPUP, GUEST_ORDER_POPUP,
    PROFILE_ADYEN_CARD_REGISTRATION_POPUP,
    SLOW_SERVICE_POPUP, STRIPE_THREE_DS_POPUP,
    SWISH_PAY_POPUP
} from '../constants/popup.constants';

import {
    ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP, GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP,
    MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP,
    MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP,
    REPEAT_ORDER_ERROR_MESSAGE_POPUP, SWISH_PAYMENT_ERROR_MESSAGE_POPUP
} from '../components/popups/error-message/ErrorMessage';
import { getStartupParams } from "../helpers/startup-params.helper";
import { MOBILE_PAY_FORM_POPUP } from "../components/popups/mobile-pay-form/MobilePayForm";
import { LoadingStyle } from "../reducers/loading.reducer.types";
import { setUserIdentifier, trackEvent } from "../helpers/tracking.helpers";
import { ADYEN_ERROR, ADYEN_SUCCESS, SUBMIT_ADYEN_CARD_ADDITIONAL_DETAILS } from '../constants/payment.constants';
import { ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP } from '../components/popups/adyen-mobile-pay-anonymous-info/AdyenMobilePayAnonymousInfo';
import { setInfoMessage } from '../managers/client-log.manager';
import {INITIAL_ORDER_POPUP} from "../components/popups/inital-order-popup/InitialOrderPopup";
import {MINICART_POPUP} from "../components/compositions/minicart/Minicart";

const HttpMethods = {
    GET: 'GET',
    POST: 'POST',
};

//TODO handle and log errors in payload and endpoint functions

function convertObjectToFormData(objectToConvert) {
    return Object.keys(objectToConvert)
    .map(key => {
        if (objectToConvert[key] && typeof objectToConvert[key] === 'object') {
            return Object.keys(objectToConvert[key])
            .map(
                innerKey => `${encodeURIComponent(key)}[${innerKey}]=${objectToConvert[key][encodeURIComponent(innerKey)]}`
            )
            .join('&');
        } else {
            return encodeURIComponent(key) + '=' + encodeURIComponent(objectToConvert[key]);
        }
    })
    .join('&');
}

const PostHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
};

function getPostBody(postData = {}, currentAuth, currentAppId?: AppId, udid?: Udid, secret?: Secret, appId?: AppId, params?: object) {
    appId = appId || currentAppId;
    udid = udid || currentAuth.udid;
    secret = secret || currentAuth.secret;

    return convertObjectToFormData({
        id: udid,
        phonegap: Platform.isNativeApp,
        webshop: false,
        pwa: Platform.isPWA,
        appVersion: Config.getAppVersion(),
        appId,
        data: encrypt(JSON.stringify(postData), secret),
        params: params || {},
    });
}

async function businessLogicSensitiveFetch(...args) {
    //@ts-ignore
    const res = await fetch(...args);
    const json = await res.json();

    return new Response(
        JSON.stringify({
            ...json,
        }),
        {
            // Custom success/error status based on an `error` key in the API response
            status: json.success === false ? 409 : json.cauth === false ? 401 : res.status,
            statusText: json.messages && json.messages.join(';').replace(/[\r\n]/g, '').replace(/[^\x00-\xFF]/g, ''), // added the last replace() to remove emojis (non ASCII characters), since those characters are not allowed in statusText
        }
    );
}

export const checkConnection = () => {
    return createAction({
        endpoint: Config.BaseServerUrl + CheckConnection,
        method: HttpMethods.GET,
        types: [CHECK_CONNECTION_REQUEST, CHECK_CONNECTION_SUCCESS, CHECK_CONNECTION_FAILURE],
    });
};

export const getRestaurant = (restaurantId, version, locale, customerGroupIds = '0') => {
    return createAction({
        endpoint: store => {
            const {
                customer: {currentCustomer},
            } = store;

            return (
                Config.BaseServerUrl +
                GetDetails.replace('{id}', restaurantId)
                .replace(
                    '{version}',
                    version || (currentCustomer && currentCustomer.restaurant && currentCustomer.restaurant.version) || '0'
                )
                .replace('{locale}', locale || store.localization.locale)
                .replace('{app_version}', Config.getAppVersion())
                .replace('{group}', customerGroupIds)
            );
        },
        method: HttpMethods.GET,
        types: [
            RESTAURANT_REQUEST,
            {
                type: RESTAURANT_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            data: {
                                ...json.data,
                                locale, //TODO receive from backend,
                                customerGroupIds, //TODO receive from backend
                            },
                        };
                    });
                },
            },
            RESTAURANT_FAILURE,
        ],
    });
};

export const getRestaurantList = (isFirstCall = false) => {

    if (getStartupParams().id) {
        let currentAppId = null;

        return createAction({
            endpoint: state => {
                const {localization} = state;

                currentAppId = getCurrentAppIdSelector(state);

                return (
                    Config.BaseServerUrl +
                    GetDetails.replace('{id}', getStartupParams().id)
                    .replace(
                        '{version}',
                        '0'
                    )
                    .replace('{locale}', localization.locale)
                    .replace('{app_version}', Config.getAppVersion())
                    .replace('{group}', '0')
                );
            },
            method: HttpMethods.GET,
            types: [
                RESTAURANT_LIST_REQUEST,
                {
                    type: RESTAURANT_LIST_SUCCESS,
                    payload: (action, state, res) => {
											return res.json().then(json => {
													if (!json?.data?.restaurantType){ // todo for testing, remove !
														setInfoMessage(`RESTAURANT_LIST_SUCCESS forqtf-2216: 
															json.: ${JSON.stringify(json)}
														`);
													}
													return ({
                            ...json,
                            data: {
                                appId: currentAppId,
                                appVersion: undefined,
                                restaurants: [
                                    {
                                        address: json.data.address,
                                        cityName: '',
                                        code: '',
                                        isDoingEatInAndTakeOut: json.data.isDoingEatInAndTakeOut,
                                        isHomeDeliveryEnabled: json.data.isHomeDeliveryEnabled,
                                        latitude: json.data.latitude,
                                        longitude: json.data.longitude,
                                        name: json.data.name,
                                        phone: json.data.phone,
                                        picture: json.data.picture,
                                        restaurantId: json.data.restaurantId,
                                        restaurantType: json.data.restaurantType,
                                        thumbnail: undefined,
                                        todaySchedule: {
                                            closeAllDay: false,
                                            openAllDay: false,
                                            startDelivery: '',
                                            startPickup: '',
                                            stopDelivery: '',
                                            stopPickup: ''
                                        }
                                    }
                                ],
                                messages: [],
                                success: true
                            },
                            showLoading: getAdyenReturnModeSelector(state) === AdyenReturnModes.URL_STATE_MATCH ||
                            getAdyenReturnModeSelector(state) === AdyenReturnModes.URL_STATE_MISMATCH
                                ? null
                                : false,
                            isFirstCall,
                        })});
                    },
                },
                {
                    type: RESTAURANT_LIST_FAILURE,
                    meta: async function (action, state, res) {
                        const json = await res?.json();

                        return {
                            ...json,
                            showLoading: false,
                        };
                    },
                },
            ],
        });
    }

    return createAction({
        endpoint: state => {
            const {localization} = state;

            return (
                Config.BaseServerUrl +
                GetRestaurantList.replace('{app_id}', getCurrentAppIdSelector(state))
                .replace('{locale}', localization.locale)
                .replace('{app_version}', Config.getAppVersion())
            );
        },

        method: HttpMethods.GET,
        types: [RESTAURANT_LIST_REQUEST, {
            type: RESTAURANT_LIST_SUCCESS,
            payload: (action, state, res) => {

                return res.json().then(json => ({
                    ...json,
                    showLoading: getAdyenReturnModeSelector(state) === AdyenReturnModes.URL_STATE_MATCH ||
                    getAdyenReturnModeSelector(state) === AdyenReturnModes.URL_STATE_MISMATCH
                        ? null
                        : false,
                    isFirstCall,
                }));
            },
        }, {
            type: RESTAURANT_LIST_FAILURE,
            meta: async function (action, state, res) {
                const json = await res?.json();

                return {
                    ...json,
                    showLoading: false,
                };
            },
        },],
    });
};

export const getRestaurantListByZip = (zip, isFromCart = false, isSuppressPopups = false, isCheckDeliveryAddress: boolean = false) => {
    return createAction({
        endpoint: state => {
            const {localization} = state;

            return (
                Config.BaseServerUrl +
                GetRestaurantListByZip.replace('{appId}', getCurrentAppIdSelector(state))
                .replace('{zip}', zip)
                .replace('{locale}', localization.locale)
                .replace('{appVersion}', Config.getAppVersion())
            );
        },
        method: HttpMethods.GET,
        fetch: businessLogicSensitiveFetch,
        types: [
            RESTAURANT_LIST_BY_ZIP_REQUEST,
            {
                type: RESTAURANT_LIST_BY_ZIP_SUCCESS,
                payload: (action, state, res) => {
                    const currentRestaurantList = getCurrentRestaurantListSelector(state);
                    const hidePopups = [SELECT_LOCATION_POPUP, CART_SELECT_LOCATION_POPUP, INITIAL_POPUP, ZIP_EDIT_POPUP, CART_ZIP_EDIT_POPUP];
                    if (!isCheckDeliveryAddress) {
                        hidePopups.push(DELIVERY_ADDRESS_POPUP);
                        hidePopups.push(CART_DELIVERY_ADDRESS_POPUP);
                    }
                    if (isSuppressPopups) {
                        return res.json().then(json => json);
                    } else {
                        return res.json().then(json => ({
                            ...json,
                            showPopup: currentRestaurantList.length > 1
                                ? (isFromCart ? CART_SELECT_LOCATION_POPUP : SELECT_LOCATION_POPUP)
                                : null,
                            hidePopups:
                                currentRestaurantList.length > 1
                                    ? undefined
                                    : hidePopups,
                            zip,
                        }));
                    }

                },
            },
            RESTAURANT_LIST_BY_ZIP_FAILURE,
        ],
    });
};

export const loginAnonymous = (appId, locale) => {
    return createAction({
        endpoint: Config.BaseServerUrl + LoginAnonymous,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: convertObjectToFormData({
            phonegap: Platform.isNativeApp,
            appVersion: Config.getAppVersion(),
            appId,
            locale,
        }),
        types: [
            LOGIN_ANONYMOUS_REQUEST,
            {
                type: LOGIN_ANONYMOUS_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({...json, appId}));
                },
            },
            LOGIN_ANONYMOUS_FAILURE,
        ],
    });
};

export const resignup = (restaurantId, udid, secret) => {
    return createAction({
        endpoint: Config.BaseServerUrl + Resignup,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    date: Date.now,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state),
                udid,
                secret
            );
        },
        types: [
            RESIGNUP_REQUEST,
            {
                type: RESIGNUP_SUCCESS,
                payload: (action, state, res) => {
                    const appId = getCurrentAppIdSelector(state);

                    return res.json().then(json => ({...json, appId}));
                },
            },
            RESIGNUP_FAILURE,
        ],
    });
};

export const getCustomer = restaurantId => {
    let requestAuth = null;

    return createAction({
        endpoint: Config.BaseServerUrl + GetCustomerDetails.replace('{app_version}', Config.getAppVersion()),
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            requestAuth = getCurrentAuthSelector(state);

            return getPostBody(
                {
                    restaurantId,
                },
                requestAuth,
                getCurrentAppIdSelector(state),
                requestAuth?.udid,
                requestAuth?.secret
            );
        },
        types: [
            CUSTOMER_REQUEST,
            {
                type: CUSTOMER_SUCCESS,
                payload: (action, state, res) => {
                    const {auth, appState} = state;
                    const previousCustomer = getCurrentCustomerSelector(state);

                    return res.json().then(json => {
                        let decryptedData = decrypt(json.data, requestAuth?.secret);

                        if (decryptedData.languages) {
                            //Temporary
                            //TODO remove when all languages are translated
                            const supportedLanguages = ['en', 'nb', 'fi', 'de', 'da', 'sv'];
                            decryptedData.languages = decryptedData.languages
                            .split(',')
                            .filter(language => supportedLanguages.includes(language))
                            .join(',');
                        }

                        if (!decryptedData.appId) {
                            //Temporary
                            //TODO remove when backend fix is released
                            decryptedData.appId = 'default';
                        }

                        decryptedData.fetchedTimestamp = Date.now();
                        // Track user who is logged in
                        setUserIdentifier(decryptedData.customerId);
                        trackEvent({
                            event: 'Log In',
                            properties: {
                                'Customer Id': decryptedData.customerId,
                                'Venue Id': decryptedData?.restaurant?.restaurantId,
                            }
                        });
                        return {
                            ...json,
                            data: decryptedData,
                            udid: requestAuth?.udid,
                            previousRestaurant: previousCustomer?.restaurant?.restaurantId !== decryptedData?.restaurant?.restaurantId
                                ? previousCustomer?.restaurant
                                : undefined,
                            showPopup: decryptedData?.restaurant?.isSlowService ? SLOW_SERVICE_POPUP : null
                        };
                    });
                },
            },
            {
                type: CUSTOMER_FAILURE,
                meta: async function (action, state, res) {
                    const json = await res.json();
                    return {
                        cauth: json.cauth,
                        appId: getCurrentAppIdSelector(state),
                    };
                },
            }
        ],
    });
};

export const getMenu = (restaurantId: RestaurantId, menuVersion, customerGroup) => {
    return createAction({
        endpoint: ({customer: {currentCustomer}}) => {
            const locale = currentCustomer ? currentCustomer.locale : DefaultValues.locale;

            return (
                Config.BaseServerUrl +
                GetMenu.replace('{id_restaurant}', restaurantId.toString())
                .replace('{menu_version}', menuVersion ? menuVersion : '0')
                .replace('{group}', customerGroup ? customerGroup : '0')
                .replace('{locale}', locale)
                .replace('{app_version}', Config.getAppVersion())
            );
        },
        method: HttpMethods.GET,
        types: [
            MENU_REQUEST,
            {
                type: MENU_SUCCESS,
                payload: (action, {customer: {currentCustomer}}, res) => {
                    const locale = currentCustomer ? currentCustomer.locale : DefaultValues.locale;

                    return res.json().then(json => {
                        let menuUpdates = json.data;

                        if (!isArray(json.data)) {
                            menuUpdates = [
                                {
                                    restaurantId: restaurantId,
                                    menu: menuUpdates,
                                },
                            ];
                        }

                        menuUpdates.forEach((menuUpdate: Menu) => {
                            //TODO receive these from server
                            menuUpdate.locale = locale;
                            menuUpdate.customerGroup = customerGroup;
                            menuUpdate.version = menuVersion;

                            //Temporary
                            //TODO remove after iframe items are supported
                            menuUpdate.menu.menu = menuUpdate.menu.menu
                            .map(mainCategory => {
                                if (
                                    mainCategory.type === MainCategoryTypes.bookTable ||
                                    mainCategory.type === MainCategoryTypes.info
                                ) {
                                    return null;
                                }

                                return {
                                    ...mainCategory,
                                    categories: mainCategory.categories
                                    .map(category => {
                                        return {
                                            ...category,
                                            entries: category.entries.filter(entry => !entry.iframeSrc),
                                        };
                                    })
                                    .filter(category => category.entries.length > 0),
                                };
                            })
                            .filter(mainCategory => mainCategory && mainCategory.categories.length > 0);
                        });

                        return {
                            ...json,
                            data: menuUpdates,
                            currentCustomer,
                        };
                    });
                },
            },
            MENU_FAILURE,
        ],
    });
};

export const getServerConfig = appId => {
    return createAction({
        endpoint: Config.BaseServerUrl + GetAppSettings.replace('{appId}', appId),
        method: HttpMethods.GET,
        fetch: businessLogicSensitiveFetch,
        types: [
            SERVER_CONFIG_REQUEST,
            {
                type: SERVER_CONFIG_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                    }));
                },
            },
            SERVER_CONFIG_FAILURE,
        ],
    });
};

export const getServerConfigByRestaurant = restaurantId => {
    return createAction({
        endpoint: Config.BaseServerUrl + GetAppSettingsByRestaurant.replace('{restaurantId}', restaurantId),
        method: HttpMethods.GET,
        fetch: businessLogicSensitiveFetch,
        types: [
            SERVER_CONFIG_BY_RESTAURANT_REQUEST,
            {
                type: SERVER_CONFIG_BY_RESTAURANT_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        restaurantId,
                    }));
                },
            },
            SERVER_CONFIG_BY_RESTAURANT_FAILURE,
        ],
    });
};

export const getDiscount = (cartData, isSuppressError) => {
    return createAction({
        endpoint: Config.BaseServerUrl + CheckDiscount,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    ...cartData,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            DISCOUNT_REQUEST,
            {
                type: DISCOUNT_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            data: {
                                ...decrypt(json.data, getCurrentAuthSelector(state).secret),
                                restaurantId: cartData.restaurantId, //TODO receive from backend
                            },
                        };
                    });
                },
            },
            {
                type: DISCOUNT_FAILURE,
                meta: async function (action, state, res) {
                    const json = await res.json();
                    return {
                        showPopup: !isSuppressError && DISCOUNT_ERROR_MESSAGE_POPUP,
                        restaurantId: cartData.restaurantId || getCurrentRestaurantIdSelector(state), //TODO receive from backend
                        isSuppressError,
                        data: decrypt(json.data, getCurrentAuthSelector(state).secret),
                    };
                },
            },
        ],
    });
};

export const getOrderDates = (restaurantId, orderAmount, pickupDate = null, zipCode = null) => {
    return createAction({
        endpoint: state => {
            const currentAppId = getCurrentAppIdSelector(state);
            let currentAuth;
            try {
                currentAuth = getCurrentAuthSelector(state);
            } catch (err) {
                console.log(err);
            }
            const udid = currentAuth.udid;

            return (
                Config.BaseServerUrl +
                GetOrderDates +
                '?' +
                'restaurantId=' +
                restaurantId +
                '&orderAmount=' +
                orderAmount +
                (pickupDate ? '&pickupDate=' + pickupDate : '') +
                (zipCode ? '&zipCode=' + zipCode : '') +
                '&id=' +
                udid +
                '&phonegap=false' +
                '&appVersion=' +
                Config.getAppVersion() +
                '&appId=' +
                currentAppId
            );
        },
        method: HttpMethods.GET,
        fetch: businessLogicSensitiveFetch,
        types: [
            ORDER_DATES_REQUEST,
            {
                type: ORDER_DATES_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        dismissError: ORDER_TIME_SLOTS,
                        dismissMessage: ORDER_TIME_SLOTS,
                        restaurantId,
                        debugRequestParams: {
                            restaurantId,
                            orderAmount,
                            pickupDate,
                            zipCode
                        }
                    }));
                },
            },
            ORDER_DATES_FAILURE,
        ],
    });
};

export const getOrderTimeSlots = (restaurantId, orderAmount, pickupDate, zipCode = null) => {
    return createAction({
        endpoint: (state) => {
            const currentAppId = getCurrentAppIdSelector(state);
            const udid = getCurrentAuthSelector(state).udid;

            return (
                Config.BaseServerUrl +
                GetOrderTimeSlots +
                '?' +
                'restaurantId=' +
                restaurantId +
                '&orderAmount=' +
                orderAmount +
                '&pickupDate=' +
                pickupDate +
                (zipCode ? '&zipCode=' + zipCode : '') +
                '&id=' +
                udid +
                '&phonegap=false' +
                '&appVersion=' +
                Config.getAppVersion() +
                '&appId=' +
                currentAppId
            );
        },
        method: HttpMethods.GET,
        fetch: businessLogicSensitiveFetch,
        types: [ORDER_TIME_SLOTS_REQUEST, {
            type: ORDER_TIME_SLOTS_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => ({
                    ...json,
                    dismissError: ORDER_DATES,
                    dismissMessage: ORDER_DATES,
                    debugRequestParams: {
                        restaurantId,
                        orderAmount,
                        pickupDate,
                        zipCode
                    }
                }));
            },
        }, ORDER_TIME_SLOTS_FAILURE],
    });
};

export const setPhone = phone => {
    return createAction({
        endpoint: Config.BaseServerUrl + SetPhone,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                    phone,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SET_PHONE_REQUEST,
            {
                type: SET_PHONE_SUCCESS,
                payload: (action, {appState, auth}, res) => {
                    return res.json().then(json => ({
                        ...json,
                        showPopup: VERIFICATION_CODE_POPUP,
                        dismissError: CHECK_PHONE_CODE,
                    }));
                },
            },
            SET_PHONE_FAILURE,
        ],
    });
};

export const checkPhoneCode = (phoneCode, termsConsent, marketingConsent, shouldOpenCartOnLogin) => {
    return createAction({
        endpoint: Config.BaseServerUrl + CheckPhoneCode,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                    phoneCode: phoneCode,
                    acceptTerms: termsConsent,
                    allowMarketing: marketingConsent,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            CHECK_PHONE_CODE_REQUEST,
            {
                type: CHECK_PHONE_CODE_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            hidePopups: [VERIFICATION_CODE_POPUP, PHONE_POPUP, GUEST_ORDER_POPUP, INITIAL_ORDER_POPUP, MINICART_POPUP],
                            restaurantId: getCurrentRestaurantIdSelector(state),
                            data: {
                                ...decrypt(json.data, getCurrentAuthSelector(state).secret),
                                appId: getCurrentAppIdSelector(state), //TODO receive from backend
                                shouldOpenCartOnLogin,
                            },
                        };
                    });
                },
            },
            {
                type: CHECK_PHONE_CODE_FAILURE,
                meta: (action, state, res) => {
                    return res.json().then(json => {
                        const decryptedData = decrypt(json.data, getCurrentAuthSelector(state).secret);

                        if (decryptedData.phoneReset) {
                            return {
                                hidePopups: [VERIFICATION_CODE_POPUP],
                            };
                        } else {
                            return null;
                        }
                    });
                },
            },
        ],
    });
};

//TODO consume SEND_ORDER_SUCCESS in all stores
export const sendOrder = (order, password) => {
    return createAction({
        endpoint: Config.BaseServerUrl + SendOrder,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    order_data: order,
                    pass: password,
                    isPhonegap: Platform.isNativeApp,
                    appVersion: Config.getAppVersion(),
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SEND_ORDER_REQUEST,
            {
                type: SEND_ORDER_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        const decryptedData = decrypt(json.data, getCurrentAuthSelector(state).secret);
                        const isOrderSent = !decryptedData.redirectUrl &&
                            !decryptedData.stripeClientSecret &&
                            !decryptedData.adyenClientKey &&
                            decryptedData.paymentType !== PaymentTypes.payWithVipps;

                        const currentOrders = getCurrentOrdersSelector(state);
                        trackEvent({
                            event: 'Place Order Success',
                            properties: {
                                'Order Id': decryptedData.order.orderId,
                                'Venue Id': decryptedData.order.restaurantId,
                            }
                        });
                        let showPopup = null;

                        if (decryptedData.adyenClientKey) {
                            const popupMap = {
                                [PaymentTypes.payWithAdyenCard]: ADYEN_CARD_REGISTRATION_POPUP,
                                [PaymentTypes.payWithSwish]: SWISH_PAY_POPUP,
                                [PaymentTypes.payWithGooglePay]: ADYEN_GOOGLE_PAY_POPUP,
                                [PaymentTypes.payWithApplePay]: ADYEN_APPLE_PAY_POPUP,
                                [PaymentTypes.payWithMobilePay]: MOBILE_PAY_FORM_POPUP,
                            };
                            showPopup = popupMap[decryptedData.order.paymentType] ?? null;
                        }
                        if (decryptedData.stripeClientSecret && decryptedData.order.paymentType === PaymentTypes.payWithStripe && !decryptedData.redirectUrl) {
                            showPopup = STRIPE_CARD_REGISTRATION_POPUP;
                        }
                        if (decryptedData.redirectUrl && decryptedData.order.paymentType === PaymentTypes.payWithVipps) {
                            showPopup = VIPPS_PAYMENT_FRAME_POPUP;
                        }
                        if (decryptedData.stripeClientSecret && decryptedData.order.paymentType === PaymentTypes.payWithStripe && decryptedData.redirectUrl) {
                            showPopup = STRIPE_THREE_DS_POPUP;
                        }
                        if (isOrderSent && currentOrders.length === 0) {
                            showPopup = ADD_TO_HOME_SCREEN_POPUP;
                        }
                        return {
                            ...json,
                            showPopup,
                            hidePopups: [CONFIRM_GUEST_ORDER_POPUP],
                            isOrderSent,
                            initialOrder: order,
                            requestData: {
                                passwordLength: password?.length > 0,
                                order,
                            },
                            data: {
                                ...decryptedData,
                            },
                        };
                    });
                },
            },
            {
                type: SEND_ORDER_FAILURE,
                meta: async function (action, state, res) {
                    const json = await res.json();

                    return {
                        showPopup: SEND_ORDER_ERROR_MESSAGE_POPUP,
                        restaurantId: order.restaurantId, //TODO receive from backend
                        requestData: {
                            passwordLength: password?.length > 0,
                            order,
                        },
                        data: decrypt(json.data, getCurrentAuthSelector(state).secret),
                    };
                },
            },
        ],
    });
};

export const getOldOrders = restaurantId => {
    return createAction({
        endpoint: Config.BaseServerUrl + OldOrders,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    restaurantId,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            OLD_ORDERS_REQUEST,
            {
                type: OLD_ORDERS_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            data: {
                                ...decrypt(json.data, getCurrentAuthSelector(state).secret),
                                restaurantId,
                            },
                        };
                    });
                },
            },
            OLD_ORDERS_FAILURE,
        ],
    });
};

export const setLocale = (locale = 'en') => {
    return createAction({
        endpoint: Config.BaseServerUrl + SetLocale,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    locale,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [SET_LOCALE_REQUEST, SET_LOCALE_SUCCESS, SET_LOCALE_FAILURE],
    });
};

export const setName = name => {
    return createAction({
        endpoint: Config.BaseServerUrl + SetUsername,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    nickname: name,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SET_NAME_REQUEST,
            {
                type: SET_NAME_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        hidePopups: [NAME_POPUP],
                        restaurantId: getCurrentRestaurantIdSelector(state),
                        data: {
                            ...decrypt(json.data, getCurrentAuthSelector(state).secret),
                        },
                    }));
                },
            },
            SET_NAME_FAILURE,
        ],
    });
};

export const setEmail = email => {
    return createAction({
        endpoint: Config.BaseServerUrl + SetEmail,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    email,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SET_EMAIL_REQUEST,
            {
                type: SET_EMAIL_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        hidePopups: [EMAIL_POPUP],
                        restaurantId: getCurrentRestaurantIdSelector(state),
                        email: email,
                    }));
                },
            },
            SET_EMAIL_FAILURE,
        ],
    });
};

export const setBirthdate = birthdate => {
    return createAction({
        endpoint: Config.BaseServerUrl + SetBirthdate,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    birthdate,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SET_BIRTHDATE_REQUEST,
            {
                type: SET_BIRTHDATE_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        hidePopups: [BIRTHDAY_POPUP],
                        restaurantId: getCurrentRestaurantIdSelector(state),
                        birthdate,
                    }));
                },
            },
            SET_BIRTHDATE_FAILURE,
        ],
    });
};

export const getCashpoints = numberOfTransactions => {
    return createAction({
        endpoint: Config.BaseServerUrl + GetCashPoints,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                    numberOfTransactions,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            CASHPOINTS_REQUEST,
            {
                type: CASHPOINTS_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            data: {
                                ...decrypt(json.data, getCurrentAuthSelector(state).secret),
                                restaurantId: getCurrentRestaurantIdSelector(state), //TODO receive from backend,
                                fetchedTimestamp: Date.now()
                            },
                        };
                    });
                },
            },
            CASHPOINTS_FAILURE,
        ],
    });
};

export const checkZip = zip => {
    return createAction({
        endpoint: Config.BaseServerUrl + CheckZip,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(null, getCurrentAuthSelector(state), getCurrentAppIdSelector(state), undefined, undefined, undefined, {
                restaurantId: getCurrentRestaurantIdSelector(state),
                zip,
            });
        },
        types: [
            CHECK_ZIP_REQUEST,
            {
                type: CHECK_ZIP_SUCCESS,
                payload: (action, {appState, auth, restaurantList}, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            hidePopups: [DELIVERY_ADDRESS_POPUP, INITIAL_POPUP],
                        };
                    });
                },
            },
            CHECK_ZIP_FAILURE,
        ],
    });
};

export const applyPromocode = promoCode => {
    return createAction({
        endpoint: Config.BaseServerUrl + ApplyPromoCode,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                    promoCode,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            APPLY_PROMOCODE_REQUEST,
            {
                type: APPLY_PROMOCODE_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            promocode: promoCode, //TODO receive from backend
                            restaurantId: getCurrentRestaurantIdSelector(state), //TODO receive from backend
                            hidePopups: [PROMOCODE_EDIT_POPUP],
                        };
                    });
                },
            },
            APPLY_PROMOCODE_FAILURE,
        ],
    });
};

export const setTable = tableNumber => {
    return createAction({
        endpoint: Config.BaseServerUrl + SetTable,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                    tableNumber,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SET_TABLE_REQUEST,
            {
                type: SET_TABLE_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            restaurantId: getCurrentRestaurantIdSelector(state), //TODO receive from backend
                            tableNumber, //TODO receive from backend
                            hidePopups: [TABLE_EDIT_POPUP],
                        };
                    });
                },
            },
            SET_TABLE_FAILURE,
        ],
    });
};

export const checkPaymentStatus = (orderId) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + CheckPaymentStatus.replace('{orderId}', orderId);
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody({
                redirectResult: getAdyenRedirectResultSelector(state),
                data: state.data,
            }, getCurrentAuthSelector(state), getCurrentAppIdSelector(state));
        },
        types: [
            CHECK_PAYMENT_STATUS_REQUEST,
            {
                type: CHECK_PAYMENT_STATUS_SUCCESS,
                payload: (action, state, res) => {

                    return res.json().then(json => {
                        const isAdyenOrder = !!getAdyenRedirectResultSelector(state);
                        const decryptedData = decrypt(json.data, getCurrentAuthSelector(state).secret);

                        let popup = null

                        // if (!isAdyenOrder) {
                        // 	popup = MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP;
                        // }
                        if (isAdyenOrder && decryptedData.status === PaymentStatuses.cancelled) {
                            popup = MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP;
                        }
                        return {
                            ...json,
                            data: {
                                ...decryptedData
                            },
                            showPopup: popup,
                            isAdyenOrder,
                            currentRestaurantId: getCurrentRestaurantIdSelector(state),
                            orderId, //TODO receive from backend,
                            showLoading: false,
                        };
                    });
                },
            },
            CHECK_PAYMENT_STATUS_FAILURE,
        ],
    });
};

export const checkPaymentStatusAnonymously = (orderId) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + CheckPaymentStatusAnonymously.replace('{orderId}', orderId);
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return convertObjectToFormData({
                redirectResult: getAdyenRedirectResultSelector(state),
                restaurantId: getCurrentRestaurantIdSelector(state),
                secret: getAdyenRedirectResultSecret(state)
            });
        },
        types: [
            CHECK_PAYMENT_STATUS_ANONYMOUSLY_REQUEST,
            {
                type: CHECK_PAYMENT_STATUS_ANONYMOUSLY_SUCCESS,
                payload: (action, state, res) => {

                    return res.json().then(json => {
                        let popup = null;
                        const userLoggedIn = !!getCurrentCustomerSelector(state)?.phone;
                        if (!userLoggedIn) {
                            popup = ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP;
                        }

                        return {
                            ...json,
                            showPopup: popup,
                            currentRestaurantId: getCurrentRestaurantIdSelector(state),
                            orderId, //TODO receive from backend,
                            anonymousPaymentCheck: !userLoggedIn,
                            showLoading: false,
                        };
                    });
                },
            },
            CHECK_PAYMENT_STATUS_ANONYMOUSLY_FAILURE,
        ],
    });
};

export const checkAdyenPayment = (stateData, returnFromAdyen) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + CheckAdyenPayment.replace('{orderId}', getCurrentTemporaryOrderIdSelector(state) || returnFromAdyen?.orderId)
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody({
                redirectResult: getAdyenRedirectResultSelector(state),
                data: stateData,
            }, getCurrentAuthSelector(state), getCurrentAppIdSelector(state));
        },
        types: [
            {
                type: CHECK_ADYEN_PAYMENT_REQUEST,
                payload: {
                    showLoading: LoadingStyle.TRANSPARENT
                }
            },
            {
                type: CHECK_ADYEN_PAYMENT_SUCCESS,
                payload: (action, state, res) => {

                    return res.json().then(json => {
                        const decryptedData = decrypt(json.data, getCurrentAuthSelector(state).secret);
                        return {
                            ...json,
                            data: {
                                ...decryptedData
                            },
                            returnFromAdyen,
                            showLoading: false,
                            showPopup: decryptedData.isFromProfile ? INITIAL_POPUP : null,
                            hidePopups: [ADYEN_CARD_REGISTRATION_POPUP],
                            currentRestaurantId: getCurrentRestaurantIdSelector(state),
                            orderId: returnFromAdyen?.orderId || getCurrentTemporaryOrderIdSelector(state), //TODO receive from backend
                        };
                    });
                },
            },
            {
                type: CHECK_ADYEN_PAYMENT_FAILURE,
                meta: {
                    showLoading: false,
                    hidePopups: [ADYEN_CARD_REGISTRATION_POPUP],
                    showPopup: ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP,
                }
            },
        ],
    });
};

export const checkSwishAdyenPayment = (stateData, reCheck = false, orderId = null) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + CheckAdyenPayment.replace('{orderId}', getCurrentTemporaryOrderIdSelector(state) || orderId)
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody({
                data: stateData,
                reCheck,
            }, getCurrentAuthSelector(state), getCurrentAppIdSelector(state));
        },
        types: [
            {
                type: CHECK_ADYEN_PAYMENT_REQUEST,
                payload: {
                    showLoading: LoadingStyle.TRANSPARENT
                }
            },
            {
                type: CHECK_ADYEN_PAYMENT_SUCCESS,
                payload: (action, state, res) => {

                    return res.json().then(json => {
                        const decryptedData = decrypt(json.data, getCurrentAuthSelector(state).secret);
                        return {
                            ...json,
                            data: {
                                ...decryptedData
                            },
                            showLoading: decryptedData.resultCode !== PaymentStatuses.authorised,
                            hidePopups: [SWISH_PAY_POPUP],
                            showPopup: decryptedData.isFromProfile ? INITIAL_POPUP : null,
                            currentRestaurantId: getCurrentRestaurantIdSelector(state),
                            orderId: getCurrentTemporaryOrderIdSelector(state), //TODO receive from backend
                        };
                    });
                },
            },
            {
                type: CHECK_ADYEN_PAYMENT_FAILURE,
                meta: {
                    showLoading: false,
                    showPopup: SWISH_PAYMENT_ERROR_MESSAGE_POPUP,
                    hidePopups: [SWISH_PAY_POPUP]
                }
            },
        ],
    });
};

export const getOrder = (orderId, isScheduledForCancel = false, isAdyenOrder = false) => {
    return createAction({
        endpoint: Config.BaseServerUrl + GetOrder.replace('{orderId}', orderId),
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody({}, getCurrentAuthSelector(state), getCurrentAppIdSelector(state));
        },
        types: [
            ORDER_REQUEST,
            {
                type: ORDER_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            isScheduledForCancel,
                            isAdyenOrder,
                            showLoading: isAdyenOrder
                                ? false
                                : null,
                            data: {
                                ...decrypt(json.data, getCurrentAuthSelector(state).secret),
                            },
                        };
                    });
                },
            },
            ORDER_FAILURE,
        ],
    });
};

export const deleteCard = () => {
    return createAction({
        endpoint: Config.BaseServerUrl + DeleteCard,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [DELETE_CARD_REQUEST, DELETE_CARD_SUCCESS, DELETE_CARD_FAILURE],
    });
};

export const emailReceipts = (email, isSubscribe, emailAllOrders) => {
    return createAction({
        endpoint: Config.BaseServerUrl + EmailReceipts,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                    email: email,
                    emailWhenOrdering: isSubscribe,
                    emailAllOrders: emailAllOrders,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            EMAIL_RECEIPTS_REQUEST,
            {
                type: EMAIL_RECEIPTS_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            hidePopups: [EMAIL_ALL_RECEIPTS_POPUP],
                        };
                    });
                },
            },
            EMAIL_RECEIPTS_FAILURE,
        ],
    });
};

export const sendReceipt = (orderId: number, email: string, emailWhenOrdering: boolean) => {
    return createAction({
        endpoint: Config.BaseServerUrl + SendReceipt,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody(
                {
                    orderId,
                    email,
                    emailWhenOrdering
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SEND_RECEIPT_REQUEST,
            {
                type: SEND_RECEIPT_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            hidePopups: [EMAIL_RECEIPT_POPUP],
                        };
                    });
                },
            },
            SEND_RECEIPT_FAILURE,
        ],
    });
};

export const resendPhoneCode = () => {
    return createAction({
        endpoint: Config.BaseServerUrl + ResendPhoneCode,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody({}, getCurrentAuthSelector(state), getCurrentAppIdSelector(state));
        },
        types: [
            RESEND_PHONE_CODE_REQUEST,
            {
                type: RESEND_PHONE_CODE_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                        };
                    });
                },
            },
            RESEND_PHONE_CODE_FAILURE,
        ],
    });
};

export const allowMarketing = (allowEmail, allowPush, allowSms) => {
    return createAction({
        endpoint: Config.BaseServerUrl + AllowMarketing,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody(
                {
                    allowEmail,
                    allowPush,
                    allowSms,
                    restaurantId: getCurrentRestaurantIdSelector(state),
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            ALLOW_MARKETING_REQUEST,
            {
                type: ALLOW_MARKETING_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            data: decrypt(json.data, getCurrentAuthSelector(state).secret),
                        };
                    });
                },
            },
            ALLOW_MARKETING_FAILURE,
        ],
    });
};

export const registerStripeCard = () => {
    return createAction({
        endpoint: state => {
            return (
                Config.BaseServerUrl +
                RegisterStripeCard.replace('{udid}', getCurrentAuthSelector(state).udid)
                .replace('{restaurantId}', getCurrentRestaurantIdSelector(state))
                .replace('{appVersion}', Config.getAppVersion())
            );
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        types: [
            REGISTER_STRIPE_CARD_REQUEST,
            {
                type: REGISTER_STRIPE_CARD_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            showPopup: PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
                        };
                    });
                },
            },
            REGISTER_STRIPE_CARD_FAILURE,
        ],
    });
};

export const getLocalization = (locale, translationVersion = 'first_start') => {
    return createAction({
        endpoint: state => {
            const browserLanguage = getBrowserShortLocaleAdaptedForBackend(getBrowserFullLocale());
            return (
                Config.BaseServerUrl +
                GetAppTranslation.replace('{locale}', locale || browserLanguage || DefaultValues.locale)
                .replace('{version}', translationVersion)
                .replace('{app_id}', getCurrentAppIdSelector(state))
                .replace('{app_version}', Config.getAppVersion())
            );
        },
        method: HttpMethods.GET,
        fetch: businessLogicSensitiveFetch,
        types: [
            LOCALIZATION_REQUEST,
            {
                type: LOCALIZATION_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            locale, //TODO fetch from backend
                        };
                    });
                },
            },
            LOCALIZATION_FAILURE,
        ],
    });
};

export const acceptTerms = marketingConsent => {
    return createAction({
        endpoint: Config.BaseServerUrl + AcceptTerms,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody(
                {
                    restaurantId: getCurrentRestaurantIdSelector(state),
                    allowMarketing: marketingConsent,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            ACCEPT_TERMS_REQUEST,
            {
                type: ACCEPT_TERMS_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        hidePopups: [TERMS_POPUP],
                        data: {
                            ...decrypt(json.data, getCurrentAuthSelector(state).secret),
                        },
                    }));
                },
            },
            ACCEPT_TERMS_FAILURE,
        ],
    });
};

export const sendClientLogs = log => {
    return createAction({
        endpoint: Config.BaseServerUrl + SendClientLog,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody(
                {
                    log,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SEND_CLIENT_LOG_REQUEST,
            {
                type: SEND_CLIENT_LOG_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        idsToSend: log.map(entry => entry.id),
                    }));
                },
            },
            SEND_CLIENT_LOG_FAILURE,
        ],
    });
};

export const cancelOrder = orderId => {
    return createAction({
        endpoint: Config.BaseServerUrl + CancelOrder,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: state => {
            return getPostBody(
                {
                    orderId,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            CANCEL_ORDER_REQUEST,
            CANCEL_ORDER_SUCCESS,
            CANCEL_ORDER_FAILURE,
        ],
    });
};

export const markPopupAsShown = popupId => {
    return createAction({
        endpoint: Config.BaseServerUrl + MarkPopupAsShown,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    popupId,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [MARK_POPUP_AS_SHOWN_REQUEST, MARK_POPUP_AS_SHOWN_SUCCESS, MARK_POPUP_AS_SHOWN_FAILURE],
    });
};

export const getHistoryOrders = () => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + AppOrders
            .replace('{udid}', getCurrentAuthSelector(state).udid)
            .replace('{app_version}', Config.getAppVersion())
            .replace('{appId}', getCurrentAppIdSelector(state));

        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {},
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [GET_HISTORY_ORDERS_REQUEST, {
            type: GET_HISTORY_ORDERS_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => ({
                    ...json,
                    data: decrypt(json.data, getCurrentAuthSelector(state).secret),
                }));
            },
        }, GET_HISTORY_ORDERS_FAILURE],
    });
};

export const repeatOrder = (orderId, isRewriteCurrentPage = false) => {
    return createAction({
        endpoint: Config.BaseServerUrl + RepeatOrder,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    orderId: orderId.toString()
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [REPEAT_ORDER_REQUEST, {
            type: REPEAT_ORDER_SUCCESS,
            payload: (action, state, res) => {
                const orderCache = getOrderCacheSelector(state);
                const order = getOrderFromCache(orderId, orderCache);

                const currentRestaurantList = getCurrentRestaurantListSelector(state);
                const restaurantId = order.pickupPlaceId ? order.pickupPlaceId : order.restaurantId;
                const orderRestaurant = currentRestaurantList.find(restaurant => restaurant.restaurantId === restaurantId);

                const orderingType = getOrderingTypeFromOrder(order, orderRestaurant);

                let popupToShow = null;

                if (orderingType === OrderingTypes.dineIn) {
                    popupToShow = TABLE_EDIT_POPUP;
                }

                if (orderingType === OrderingTypes.delivery) {
                    popupToShow = CART_DELIVERY_ADDRESS_POPUP;
                }

                return res.json().then(json => {
                    return {
                        ...json,
                        showPopup: popupToShow,
                        hidePopups: [REPEAT_ORDER_CONFIRMATION_POPUP, REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP, ORDERS_POPUP, SELECT_LOCATION_POPUP, INITIAL_POPUP, ADD_TO_HOME_SCREEN_POPUP],
                        isRewriteCurrentPage,
                        data: decrypt(json.data, getCurrentAuthSelector(state).secret),
                        orderingType,
                        comment: order.comment,
                        numberOfPeople: order.numberOfPeople,
                    };
                });
            },
        }, {
            type: REPEAT_ORDER_FAILURE,
            meta: async function (action, state, res) {
                const json = await res.json();

                return {
                    showPopup: REPEAT_ORDER_ERROR_MESSAGE_POPUP,
                    hidePopups: [REPEAT_ORDER_CONFIRMATION_POPUP, REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP],
                    data: decrypt(json.data, getCurrentAuthSelector(state).secret),
                };
            },
        },],
    });
};

export const initAdyenPayment = () => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + InitAdyenPayment
            .replace('{orderId}', getCurrentTemporaryOrderIdSelector(state));
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    data: {
                        paymentMethod: {
                            type: "mobilepay"
                        }
                    },
                    returnUrl: window.location.origin + window.location.pathname,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            {
                type: INIT_ADYEN_PAYMENT_REQUEST,
                payload: {
                    showLoading: LoadingStyle.TRANSPARENT
                }
            },
            {
                type: INIT_ADYEN_PAYMENT_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            data: decrypt(json.data, getCurrentAuthSelector(state).secret)
                        }
                    });
                },
            },
            {
                type: INIT_ADYEN_PAYMENT_FAILURE,
                meta: {
                    showLoading: false,
                    showPopup: MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP
                }
            }
            ,
        ],
    });
}

export const initAdyenCardPayment = (stateData, redirectToOrder: boolean = true) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + InitAdyenPayment
            .replace('{orderId}', getCurrentTemporaryOrderIdSelector(state));
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    data: stateData,
                    returnUrl: window.location.origin + window.location.pathname,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            {
                type: REGISTER_ADYEN_CARD_REQUEST,
                payload: {
                    showLoading: LoadingStyle.TRANSPARENT
                }
            },
            {
                type: ADYEN_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        const data = decrypt(json.data, getCurrentAuthSelector(state).secret);
                        const openOrder = json.success === false || data.action.type === 'redirect' || data.action.type === 'threeDS2' ? false : redirectToOrder;
                        return {
                            orderId: getCurrentTemporaryOrderIdSelector(state),
                            hidePopups: [data.action.resultCode === PaymentStatuses.authorised ? ADYEN_CARD_REGISTRATION_POPUP : null],
                            restaurantId: getCurrentRestaurantIdSelector(state),
                            redirectToOrder: openOrder,
                            ...data,
                            showLoading: false,
                        };
                    });
                },
            },
            {
                type: ADYEN_ERROR,
                meta: {
                    showLoading: false,
                    hidePopups: [ADYEN_CARD_REGISTRATION_POPUP],
                    showPopup: ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP,
                }
            },
        ],
    });
};

export const registerAdyenCard = () => {
    return createAction({
        endpoint: state => {
            return (
                Config.BaseServerUrl +
                RegisterAdyenCard.replace('{udid}', getCurrentAuthSelector(state).udid)
                .replace('{restaurantId}', getCurrentRestaurantIdSelector(state))
                .replace('{appVersion}', Config.getAppVersion())
            );
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        types: [
            REGISTER_ADYEN_CARD_REQUEST,
            {
                type: PROFILE_ADYEN_CARD_REGISTRATION_POPUP,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        return {
                            ...json,
                            showPopup: ADYEN_CARD_REGISTRATION_POPUP,
                        };
                    });
                },
            },
            REGISTER_ADYEN_CARD_FAILURE,
        ],
    });
};

export const initSwishPayment = (stateData) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + InitAdyenPayment
            .replace('{orderId}', getCurrentTemporaryOrderIdSelector(state));
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    data: stateData,
                    returnUrl: window.location.origin + window.location.pathname,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            {
                type: SUBMIT_SWISH_PAY_REQUEST,
                payload: {
                    showLoading: LoadingStyle.TRANSPARENT
                }
            },
            {
                type: SUBMIT_SWISH_PAY_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        const data = decrypt(json.data, getCurrentAuthSelector(state).secret);
                        return {
                            orderId: getCurrentTemporaryOrderIdSelector(state),
                            hidePopups: [data.action.resultCode === PaymentStatuses.authorised ? ADYEN_CARD_REGISTRATION_POPUP : null],
                            restaurantId: getCurrentRestaurantIdSelector(state),
                            ...data,
                            showLoading: false,
                        };
                    });
                },
            },
            {
                type: SUBMIT_SWISH_PAY_FAILURE,
                meta: {
                    showLoading: false,
                    hidePopups: [SUBMIT_SWISH_PAY_FAILURE],
                }
            },
        ],
    });
};

export const initGooglePayPayment = (stateData) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + InitAdyenPayment
            .replace('{orderId}', getCurrentTemporaryOrderIdSelector(state));
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    data: stateData,
                    returnUrl: window.location.origin + window.location.pathname,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            {
                type: SUBMIT_GOOGLE_PAY_REQUEST,
                payload: {
                    showLoading: LoadingStyle.TRANSPARENT
                }
            },
            {
                type: SUBMIT_GOOGLE_PAY_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        const data = decrypt(json.data, getCurrentAuthSelector(state).secret);
                        return {
                            orderId: getCurrentTemporaryOrderIdSelector(state),
                            hidePopups: [data.action.resultCode === PaymentStatuses.authorised ? ADYEN_GOOGLE_PAY_POPUP : null],
                            restaurantId: getCurrentRestaurantIdSelector(state),
                            ...data,
                            showLoading: false,
                            redirectToOrder: true
                        };
                    });
                },
            },
            {
                type: SUBMIT_GOOGLE_PAY_FAILURE,
                meta: {
                    showLoading: false,
                    hidePopups: [ADYEN_GOOGLE_PAY_POPUP],
                    showPopup: GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP
                }
            },
        ],
    });
};
export const initApplePayPayment = (stateData) => {
    return createAction({
        endpoint: state => {
            return Config.BaseServerUrl + InitAdyenPayment
            .replace('{orderId}', getCurrentTemporaryOrderIdSelector(state));
        },
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    data: stateData,
                    returnUrl: window.location.origin + window.location.pathname,
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            {
                type: SUBMIT_APPLE_PAY_REQUEST,
                payload: {
                    showLoading: LoadingStyle.TRANSPARENT
                }
            },
            {
                type: SUBMIT_APPLE_PAY_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => {
                        const data = decrypt(json.data, getCurrentAuthSelector(state).secret);
                        return {
                            orderId: getCurrentTemporaryOrderIdSelector(state),
                            hidePopups: [data.action.resultCode === PaymentStatuses.authorised ? ADYEN_APPLE_PAY_POPUP : null],
                            restaurantId: getCurrentRestaurantIdSelector(state),
                            ...data,
                            showLoading: false,
                            redirectToOrder: true
                        };
                    });
                },
            },
            {
                type: SUBMIT_APPLE_PAY_FAILURE,
                meta: {
                    showLoading: false,
                    hidePopups: [ADYEN_APPLE_PAY_POPUP],
                    showPopup: GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP
                }
            },
        ],
    });
};

export const setGuestInfo = (name: string, phone: string, acceptTerms: boolean) => {
    return createAction({
        endpoint: Config.BaseServerUrl + SetGuestInfo,
        method: HttpMethods.POST,
        fetch: businessLogicSensitiveFetch,
        headers: {
            ...PostHeaders,
        },
        body: (state) => {
            return getPostBody(
                {
                    phone,
                    name,
                    acceptTerms,
                    restaurantId: getCurrentRestaurantIdSelector(state),
                },
                getCurrentAuthSelector(state),
                getCurrentAppIdSelector(state)
            );
        },
        types: [
            SET_GUEST_REQUEST,
            {
                type: SET_GUEST_SUCCESS,
                payload: (action, state, res) => {
                    return res.json().then(json => ({
                        ...json,
                        hidePopups: [GUEST_ORDER_POPUP, MINICART_POPUP],
                    }));
                },
            },
            SET_GUEST_FAILURE,
        ],
    });
};
